import { render } from "./SJTXinventory.vue?vue&type=template&id=30190c7d&scoped=true"
import script from "./SJTXinventory.vue?vue&type=script&lang=js"
export * from "./SJTXinventory.vue?vue&type=script&lang=js"

import "./SJTXinventory.vue?vue&type=style&index=0&id=30190c7d&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-30190c7d"

export default script